import { useParams } from 'react-router-dom';

import { PageShell } from './_PageShell';

export function UserProfile() {
  const { id } = useParams<{ id: string }>();
  return (
    <PageShell title={`User ${id}`} subtitle="Coming soon">
      <p className="text-sm text-hint">User profile screen — port from mobile-app.</p>
    </PageShell>
  );
}
